import { render, staticRenderFns } from "./ExportProductInvoice.vue?vue&type=template&id=5047d3c4&scoped=true&"
import script from "./ExportProductInvoice.vue?vue&type=script&lang=js&"
export * from "./ExportProductInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ExportProductInvoice.vue?vue&type=style&index=0&id=5047d3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047d3c4",
  null
  
)

export default component.exports